import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';

export default class IntegrationTelemetryAdapter extends ApplicationAdapter {
  host = config.integrationTelemetryApiHost;
  namespace = 'a/integration-telemetry';
}
